module.exports = __webpack_public_path__ + "img/client3.1f73ec65.png";